import module from 'fan/proyecto/module.js'

export const FanProyectoCatalogosDepartamentosSchema = {
  id: 'number',
  clase: 'number',
}

export class FanProyectoColaboradoresRegistrosPatronalesService {
  constructor ($http) {
    this.$http = $http
  }

  get (idProyecto) {
    return this.$http.get('/api2/proyecto/configuracion/catalogos/registros-patronales', {
      params: {idProyecto},
      schema: FanProyectoCatalogosDepartamentosSchema,
    })
  }
}

module.service('FanProyectoColaboradoresRegistrosPatronalesService', FanProyectoColaboradoresRegistrosPatronalesService)



// WEBPACK FOOTER //
// ./src/fan/proyecto/services/Proyecto/Colaboradores/RegistrosPatronales.js